import React, { PropTypes, Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'
import TrafficRow from './trafficRow'

export default class PrintTable extends Component {
  static propTypes = {
    thisMonday: PropTypes.object,
    records: PropTypes.array,
    projects: PropTypes.array,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { thisMonday, records, projects } = this.props

    const projectNames = misc.getDict(projects, 'name')
    const wdName = ['一', '二', '三', '四', '五', '六', '日']
    const weekdayStrings = [];
    [1, 2, 3, 4, 5, 6, 0].forEach(wd => {
      weekdayStrings.push(misc.getDateString(thisMonday, wd))
    })
    const tableRows = []
    weekdayStrings.forEach((dateString, i) => {
      records.forEach(record => {
        if (record.dateString === dateString) {
          const { projectId, note, tSegments } = record
          const tTime = misc.getTTime(record)
          if (tTime !== 0) {
            tableRows.push(
              <TrafficRow
                key={record._id}
                date={dateString}
                weekDay={wdName[i]}
                project={projectNames[projectId]}
                task="交通加班"
                tTime={(tTime / 2.0).toFixed(1)}
                tSegments={tSegments}
                note={note}
              />
            )
          }
        }
      })
    })

    if (tableRows.length === 0) return null

    return (
      <table className={styles.printTable}>
        <tbody>
          <tr>
            <th>日期</th>
            <th>星期</th>
            <th>專案名稱</th>
            <th>內容代碼</th>
            <th>時數</th>
            <th>交通時段</th>
            <th>註解</th>
          </tr>
          {tableRows}
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/printTraffic.jsx